<div class="card widget-richieste mb-0" [class.rounded-pill]="miniMode">
    <div class="card-body">
        <span class="widget-icon" aria-hidden="true"><em class="fas {{ icon }}"></em></span>
        <div class="widget-text">
            <div class="widget-value">{{ value ?? '–' }}</div>
            <div class="widget-label" *ngIf="!miniMode">{{ label | translate }}</div>
        </div>
        <em class="fas fa-chevron-right widget-arrow" aria-hidden="true"></em>
    </div>
</div>
